/*
 * compares the user against a OR list of permssion
 * where a permission is a non-null value
 */
export const isAuthorized = (user, permissions) => {
    // find a true value
    return permissions.some((p) => {
        const compareProps = Object.keys(p).filter(
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        (key) => p[key] !== null && p[key] !== undefined);
        // find a failure
        return !compareProps.some((prop) => {
            return p[prop] !== user[prop];
        });
    });
};
export const ACCOUNT_ADMIN_PERMISSIONS = [
    {
        isAccountAdmin: true,
        emailVerified: true
    }
];
export const ADMIN_PERMISSIONS = [
    {
        isAdmin: true,
        emailVerified: true
    }
];
export const SUPPORT_ADMIN_PERMISSIONS = [
    {
        isAdmin: true,
        emailVerified: true
    },
    {
        isSupport: true,
        emailVerified: true
    }
];
export const DOWNLOADER_PERMISSIONS = [
    {
        isDownloader: true,
        emailVerified: true
    }
];
export const REVIEWER_PERMISSIONS = [
    {
        isReviewer: true,
        emailVerified: true
    }
];
